// MODULES
import React from "react";
import Modal from "../../../../components/Modal/Modal";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import Signatory from "./Signatory";
import i18n from "../../../../helpers/i18n";

export default class SignModal extends React.PureComponent {
	state = _getInitialState.call(this);

	render() {
		const {visible, title, buttonText, signOnScreenChecked, signOnScreenEnabled, onCloseModal, onSign, onSignOnScreenChange, isSigning, signatories, onSignatoryCheckedChanged} = this.props;

		const signatoriesHeader = signatories.length === 1 ? i18n("general", "signatory") : i18n("general", "signatories");
		const buttonCta = (buttonText === undefined || buttonText.length === 0) ? i18n("general", "sign_with_bank_id") : buttonText;

		return (
			<Modal
				className="Cob-SignAgreement-SignModal"
				visible={visible}
				title={title}>

				<h3>{signatoriesHeader}</h3>

				{signatories.map((signatoryData, index) => (
					<Signatory
						key={index}
						data={signatoryData}
						index={index}
						selectable={signatories.length > 1}
						selectedSignatoriesAmount={signatories.filter(s => s.selected !== false).length}
						onChange={onSignatoryCheckedChanged}
					/>
				))}

				{signOnScreenEnabled && (
					<div className={"row neutral"}>
						<div className={"column"}>
							<Checkbox
								label={i18n("general", "sign_on_screen")}
								checked={signOnScreenChecked}
								onChange={onSignOnScreenChange}
							/>
						</div>
					</div>
				)}

				{signOnScreenChecked && (
					<div className={"row notice"}>
						<div className={"column"}>
							<p>{i18n("general", "sign_on_screen_text_1")}</p>

							<ul>
								<li>{i18n("general", "sign_on_screen_text_2")}</li>
								<li>{i18n("general", "sign_on_screen_text_3")}</li>
								<li>{i18n("general", "sign_on_screen_text_4")}</li>
							</ul>

							<p><strong>{i18n("general", "sign_on_screen_text_5")}</strong></p>
						</div>
					</div>
				)}

				<Modal.ButtonsContainer>
					<Modal.Button
						label={i18n("general", "cancel")}
						onClick={onCloseModal}
						disabled={isSigning}/>

					<Modal.Button
						key="go-sign-page"
						label={buttonCta}
						appearance="primary"
						onClick={onSign}
						disabled={isSigning}
						filled/>
				</Modal.ButtonsContainer>
			</Modal>
		);
	}
}


function _getInitialState() {
	return {
		signOnScreenChecked: false
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/SignModal/SignModal.js